import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { type Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";

import { productOrdersActions } from "@fitness-app/app-store";

import { productApi, useAppDispatch } from "~/store/initializeStore";

type CancelOrderPayload = {
  productId: string;
  orderId: string;
};

export const useCancelOrder = (selectedMonth?: Dayjs, ownerId?: string) => {
  const { t } = useTranslation("products");
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();
  const key = "cancelOrder";

  return useMutation({
    mutationFn: async (payload: CancelOrderPayload) => {
      message.loading({ content: "Trwa przetwarzanie operacji...", key });
      const response = await productApi.post("/manual-payment/cancel", payload);
      return response.data;
    },
    onSuccess: (_, payload) => {
      message.destroy(key);
      void message.success(t("messages.success.orderCanceled"));
      // Invalidate relevant queries to refetch updated data
      void queryClient.invalidateQueries(["productsTransactions"]);
      if (selectedMonth) {
        void dispatch(productOrdersActions.fetchOrders({ productId: payload.productId, selectedMonth, ownerId }));
      }
    },
    onError: () => {
      void message.destroy(key);
      void message.error(t("messages.error.orderCanceling"));
    },
  });
};
